import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    water_damage: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2A1,1 0 0,1 13,3A1,1 0 0,1 12,4A1,1 0 0,1 11,3A1,1 0 0,1 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V19A2,2 0 0,0 5,21H11V19.13L7.5,15.63L9.5,13.63L12,16.13L14.5,13.63L16.5,15.63L13,19.13V21H19A2,2 0 0,0 21,19V9Z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    air: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M14.6,16.6L19.2,12L14.6,7.4L13.2,8.8L15.7,11.3H8.7V12.7H15.7L13.2,15.2L14.6,16.6M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z"/>
      </svg>
    ),
    security: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11.5C15.4,11.5 16,12.4 16,13V16C16,16.6 15.6,17 15,17H9C8.4,17 8,16.6 8,16V13C8,12.4 8.4,11.5 9,11.5V10C9,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.2,8.7 10.2,10V11.5H13.8V10C13.8,8.7 12.8,8.2 12,8.2Z"/>
      </svg>
    ),
    biotech: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M13,2V8C13,9.1 13.9,10 15,10H21C21,8.9 20.1,8 19,8H15V2H13M7,4V8C7,9.1 7.9,10 9,10H11V8H9V4H7M9,12A1,1 0 0,0 8,13A1,1 0 0,0 9,14A1,1 0 0,0 10,13A1,1 0 0,0 9,12M15,12A1,1 0 0,0 14,13A1,1 0 0,0 15,14A1,1 0 0,0 16,13A1,1 0 0,0 15,12M11,14V16C11,17.1 11.9,18 13,18H19C20.1,18 21,17.1 21,16V14H11M3,16V22H5V20H7V18H5V16H3Z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    build: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const WaterDamageRestorationLanding = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'water damage restoration business'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Basement Flooding Emergency",
      time: "Sunday, 11:45 PM",
      customer: "My basement is completely flooded from a burst pipe! Water is everywhere and I need help immediately before it gets worse.",
      response: "This is a water damage emergency requiring immediate response. I'm dispatching our 24/7 emergency crew within 30 minutes with industrial water extraction and drying equipment.",
      outcome: "$3,500 emergency restoration",
      color: "blue"
    },
    {
      type: "Storm Damage Response",
      time: "Saturday, 6:15 AM", 
      customer: "The storm last night caused a roof leak and there's water damage in multiple rooms. I need someone today.",
      response: "Storm damage requires fast action to prevent mold growth. I can schedule our certified restoration team for this morning with moisture detection and dehumidification equipment.",
      outcome: "$4,200 storm restoration",
      color: "blue"
    },
    {
      type: "Mold Remediation",
      time: "Wednesday, 2:30 PM",
      customer: "I discovered black mold behind my bathroom wall after a leak. This is a health concern for my family.",
      response: "Mold remediation is critical for health and safety. I'll schedule our licensed mold specialists for tomorrow with containment barriers and HEPA filtration systems.",
      outcome: "$2,800 mold remediation",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Water damage calls come at all hours. The AI handles emergencies professionally while I focus on getting crews to the scene quickly.",
      author: "Robert K.",
      business: "Emergency Water Restoration",
      result: "50% faster response time"
    },
    {
      quote: "Insurance claims require detailed documentation. The AI collects all necessary information upfront for smoother claim processing.",
      author: "Michelle L.",
      business: "Professional Restoration Services",
      result: "95% insurance approval rate"
    },
    {
      quote: "Storm seasons bring call surges. The AI schedules efficiently while I coordinate multiple emergency crews across the city.",
      author: "James R.",
      business: "Storm Damage Experts",
      result: "3x more emergency calls"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'water damage restoration business' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "AI Receptionist for Water Damage & Mold Remediation - 24/7 Emergency Response",
    "description": "AI receptionist handles water damage restoration and mold remediation calls. Emergency flood response, storm damage, and mold removal services.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist for Water Damage & Mold Remediation | 24/7 Emergency"
        description="AI receptionist for water damage restoration and mold remediation. Handle flooding emergencies, storm damage, mold removal 24/7. Never miss emergency calls."
        keywords="water damage restoration ai, mold remediation receptionist, flood emergency response, storm damage restoration, 24/7 water damage service"
        canonical="https://receptioneer.ai/water-damage-restoration"
        ogTitle="AI Receptionist for Water Damage & Mold Remediation - 24/7 Emergency"
        ogDescription="Handle water damage emergencies, flood restoration, and mold remediation with AI receptionist. 24/7 response for urgent restoration needs."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-red-900 via-red-800 to-red-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-red-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                🚨 For Emergency Restoration
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Never Miss Another
                <br />
                <span className="text-red-200">Emergency Call</span>
              </h1>
              
              <p className="text-xl text-red-100 mb-8 leading-relaxed">
                When water damage strikes, every minute counts. Your AI receptionist handles flooding emergencies, storm damage, and mold remediation 
                <strong className="text-white"> 24/7 with rapid response coordination.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-red-900 hover:bg-red-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get Emergency AI →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-red-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test Emergency Response
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-red-200 text-sm">Emergency Ready</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">$399</div>
                  <div className="text-red-200 text-sm">Per Month</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">30 min</div>
                  <div className="text-red-200 text-sm">Response Time</div>
                </div>
              </div>
            </div>

            <div className="bg-red-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-4 h-4 rounded-full animate-pulse bg-red-500"></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Emergency Customer:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                  </div>
                  
                  <div className="rounded-lg p-3 bg-red-50">
                    <div className="text-xs font-semibold mb-1 text-red-600">AI Emergency Response:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="text-lg font-black text-green-600">{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Emergency handled</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-red-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Water Damage Needs AI */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Why Water Damage Needs <span className="text-red-600">24/7 AI</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-red-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Time-Critical Emergencies</h3>
                <p className="text-gray-700 mb-6">
                  Water damage spreads rapidly. Mold growth begins in 24-48 hours. Immediate response prevents thousands in additional damage.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Burst pipes and flooding</li>
                  <li>• Storm and roof damage</li>
                  <li>• Sewage backups</li>
                  <li>• Appliance failures</li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="schedule" className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Insurance Coordination</h3>
                <p className="text-gray-700 mb-6">
                  Proper documentation and rapid response improve insurance claim approval rates and reduce out-of-pocket costs for customers.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Emergency documentation</li>
                  <li>• Insurance claim support</li>
                  <li>• Rapid response proof</li>
                  <li>• Professional reporting</li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">High-Value Projects</h3>
                <p className="text-gray-700 mb-6">
                  Water damage restoration commands premium rates. Missing emergency calls means losing $2,000-10,000+ projects to competitors.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Emergency service premiums</li>
                  <li>• Large-scale restorations</li>
                  <li>• Insurance-covered work</li>
                  <li>• Lost calls = lost revenue</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Service Coverage */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Complete <span className="text-red-600">Restoration Service</span> Coverage
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="water_damage" className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Water Damage Restoration</h3>
                    <p className="text-gray-700">Emergency water extraction, structural drying, dehumidification, and flood cleanup services.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="biotech" className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Mold Remediation</h3>
                    <p className="text-gray-700">Licensed mold removal, containment, HEPA filtration, and post-remediation verification.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="warning" className="w-8 h-8 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Storm Damage Response</h3>
                    <p className="text-gray-700">Emergency tarping, roof repairs, window boarding, and storm damage restoration.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="security" className="w-8 h-8 text-purple-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Insurance Services</h3>
                    <p className="text-gray-700">Insurance claim documentation, adjuster coordination, and scope of work preparation.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="air" className="w-8 h-8 text-teal-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Air Quality Services</h3>
                    <p className="text-gray-700">Indoor air quality testing, duct cleaning, and environmental health assessments.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="build" className="w-8 h-8 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Reconstruction</h3>
                    <p className="text-gray-700">Full restoration services from emergency response through complete reconstruction.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Restoration Pros Trust <span className="text-red-600">AI Receptionists</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-red-50 rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="water_damage" className="w-8 h-8 text-red-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-red-100 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-red-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="py-16 px-6 bg-red-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              One Emergency Call Pays for Everything
            </h2>
            
            <p className="text-xl text-red-100 mb-8">
              Water damage restoration projects range from $2,000-10,000+. One emergency call covers months of AI receptionist service.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-red-100 mb-6">per month • unlimited calls • 24/7 emergency response</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-red-900 hover:bg-red-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get Emergency AI →
              </button>
            </div>
            
            <p className="text-red-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your Restoration AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your restoration AI ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder="e.g. Robert Martinez"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder="robert@emergencyrestoration.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-red-900 hover:bg-red-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Restoration AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default WaterDamageRestorationLanding;